// 获取模块主要获取数据模块
import request from '@/utils/request';

// 获取主题数据
export const getThemeData = () => request({url: '/look/coursewareManagement/getCoursewareThemeSettingInfo', method: 'get'});

// 获取表格数据
export const getTableData = (id, current, size, name, status) => request({url: `/look/coursewareManagement/getCoursewareSceneInformationPageDto?id=${id}&current=${current}&size=${size}${name ? `&name=${name}` : ''}&status=${status}`, method: 'get'});

// 添加主题
export const addTheme = (data) => request({url: '/look/coursewareManagement/insertCoursewareThemeSetting', method: 'post', data});

// 删除主题
export const deleteTheme = (id) => request({url: `/look/coursewareManagement/deleteCoursewareThemeSetting?id=${id}`, method: 'delete'});

// 修改主题
export const changeTheme = (data) => request({url: '/look/coursewareManagement/updateCoursewareThemeSetting', method: 'put', data});

// 新增场景——基本信息
export const addBasicInfo = (data) => request({url: '/look/coursewareManagement/insertCoursewareSceneInformation', method: 'post', data});

// 获取场景——基本信息
export const getBasicInfo = (id) => request({url: `/look/coursewareManagement/getCoursewareSceneInformationById?id=${id}`, method: 'get'});

// 修改场景——基本信息
export const changeBasicInfo = (data) => request({url: '/look/coursewareManagement/updateCoursewareSceneInformation', method: 'put', data});

// 新增场景——提示页信息
export const addTipInfo = (data) => request({url: '/look/coursewareManagement/insertCoursewarePromptInformation', method: 'post', data});

// 获取场景——提示页信息
export const getTipInfo = (id) => request({url: `/look/coursewareManagement/getCoursewarePromptInformationById?id=${id}`, method: 'get'});

// 修改场景——提示页信息
export const changeTipInfo = (data) => request({url: '/look/coursewareManagement/updateCoursewarePromptInformation', method: 'put', data});

// 新增场景——答题
export const addTopic = (data) => request({url: '/look/coursewareManagement/insertCoursewareFeedbackInformatio', method: 'post', data});

// 获取场景——答题
export const getTopic = (ranges, sceneId) => request({url: `/look/coursewareManagement/getCoursewareFeedbackInformatio?ranges=${ranges}&sceneId=${sceneId}`, method: 'get'});

// 获取宫格中有值的宫格列表
export const getGridList = (sceneId) => request({url: `/look/coursewareManagement/getSceneList?sceneId=${sceneId}`, method: 'get'});

// 删除场景——答题
export const deleteTopic = (ranges, sceneId) => request({url: `/look/coursewareManagement/deleteCoursewareFeedbackInformatio?ranges=${ranges}&sceneId=${sceneId}`, method: 'delete'});

// 修改场景——答题
export const changeTopic = (data) => request({url: '/look/coursewareManagement/updateCoursewareFeedbackInformatio', method: 'put', data});

// 新增答案区详情
export const addDetailed = (data) => request({url: '/look/coursewareManagement/insertCoursewareThemeDetailedNew', method: 'post', data});

// 获取答案区详情
export const getDetailed = (sceneId) => request({url: `/look/coursewareManagement/getCoursewareThemeDetailedNew?sceneId=${sceneId}`, method: 'get'});

// 修改答案区详情
export const changeDetailed = (data) => request({url: '/look/coursewareManagement/updateCoursewareThemeDetailedNew', method: 'put', data});

// 删除答案区详情
export const deleteDetailed = (id) => request({url: `/look/coursewareManagement/deleteCoursewareThemeDetailedNew?id=${id}`, method: 'delete'});

// 添加全局反馈
export const addGlobal = (data) => request({url: '/look/coursewareManagement/insertGlobalFeedback', method: 'post', data});

// 获取全局反馈
export const getGlobal = (sceneId) => request({url: `/look/coursewareManagement/getGlobalFeedback?sceneId=${sceneId}`, method: 'get'});

// 修改全局反馈
export const changeGlobal = (data) => request({url: '/look/coursewareManagement/updateGlobalFeedback', method: 'put', data});

// 删除全局反馈
export const deleteGlobal = (id, sceneId) => request({url: `/look/coursewareManagement/deleteGlobalFeedback?id=${id}&sceneId=${sceneId}`, method: 'delete'});

// 添加平行反馈
export const addParaItem = (data) => request({url: '/look/coursewareManagement/insertParallelFeeback', method: 'post', data});

// 获取平行反馈
export const getParaList = (sceneId) => request({url: `/look/coursewareManagement/getParallelFeeback?sceneId=${sceneId}`, method: 'get'});

// 修改平行反馈
export const updateParaItem = (data) => request({url: '/look/coursewareManagement/updateParallelFeeback', method: 'put', data});

// 删除平行反馈
export const deleteParaItem = (id, sceneId) => request({url: `/look/coursewareManagement/deleteParallelFeeback?id=${id}&sceneId=${sceneId}`, method: 'delete'});



// 删除场景
export const deleteScene = (data) => request({url: '/look/coursewareManagement/deleteCoursewareSceneInformationById', method: 'delete', data});

// 场景状态变更
export const changeStatus = (id, status) => request({url: `/look/coursewareManagement/updateCoursewareSceneInformationByStatus?id=${id}&status=${status}`, method: 'put'});

// 上传图片
export const uploadImg = (data) => request({url: '/look/coursewareManagement/updateCoursewareSceneInformationByIdImg', method: 'put', data});

// 设置勋章内获取场景
export const getScene = (id) => request({url: `/look/coursewareManagement/getCoursewareSceneInformationOption?id=${id}`, method: 'get'});

// 设置勋章回显
export const getMedal = (titleId) => request({url: `/look/coursewareManagement/getCoursewareMedalHonorById?titleId=${titleId}`, method: 'get'});

// 添加勋章
export const addMedal = (data) => request({url: '/look/coursewareManagement/insertCoursewareMedalHonor', method:'post', data});

// 删除勋章
export const deleteMedal = (id) => request({url: `/look/coursewareManagement/deleteCoursewareMedalHonor?id=${id}`, method: 'delete'});

// 修改勋章
export const editMedal = (data) => request({url: '/look/coursewareManagement/updateCoursewareMedalHonor', method: 'put', data});
